import { useEffect, useState } from 'react';
import { get } from 'lodash';
import GetRecords from '../lib/api/GetRecords';
import { APIS } from '../lib/constants/apis';
import { UseFetchStatesType } from '../lib/types/types';
import GetRecord from '../lib/api/GetRecord';
import { removeDataKeys, removeNullDeep } from '../utils/helper';

import POP_LEVEL from '../lib/api/Populations.json';

function useFetchFoerderProgramm(): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const res = await GetRecords(APIS.FörderProgramme);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { loading, data, error };
}

function useFetchFoerderProgrammDetail(id: number): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const res = await GetRecord(APIS.FörderProgramme, id, POP_LEVEL.foerderprogramm.DETAILS_SEITE);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [id]);

	return { loading, data, error };
}

export { useFetchFoerderProgramm, useFetchFoerderProgrammDetail };
